import { Box } from '@chakra-ui/react'
import DailyExposureTable from './components/DailyExposureTable/DailyExposureTable'

const DailyExposureSheet = () => {
  return (
    <Box>
        <DailyExposureTable/>
    </Box>
  )
}

export default DailyExposureSheet